import { LocalizationProvider } from "@mui/x-date-pickers";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
// If you are using date-fns v2.x, please import `AdapterDateFns`
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { sv } from "date-fns/locale";
import BrandedApp from "./BrandedApp";
import { Toaster } from "sonner";

function App() {
  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={sv}>
        <BrowserRouter>
          <Toaster />
          <BrandedApp />
        </BrowserRouter>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
